module.exports = __webpack_public_path__ + "static/media/visa-debitCard.e3ab13ea.svg";